import React, { useEffect, useMemo, useRef, useState } from "react";
import "./viewerWrapper.scss";
import { useParams } from "react-router-dom";
import { Button, Drawer, Popover } from "antd";
import { EyeOutlined, FormOutlined, LeftOutlined } from "@ant-design/icons";
import ReportForm from "../ReportForm";
import { CaseDetail } from "../../../models/CaseDetail/caseDetail.model";
import { UserRoleEnum } from "../../../enums/userRole.enum";
import AdminCaseService from "../../../services/Case/AdminCase/adminCase.service";
import DoctorCaseService from "../../../services/Case/DoctorCase/doctorCase.service";
import AuthContainer from "../../../store/container/AuthContainer";
import { AuthReducerProps } from "../../../store/reducers/authReducer";
import { CaseStatusEnum } from "../../../enums/caseStatus.enum";
import CryptoJS from "crypto-js";
import { useHistory } from "react-router-dom";
import ScanCenterCaseService from "../../../services/Case/ScanCenterCase/scanCenterCase.service";
import ViewerIframe from "../ViewerIframe";
import ProfileService from "../../../services/Profile/profile.service";
import { Admin } from "../../../models/Admin/admin.model";
import { Doctor } from "../../../models/Doctor/doctor.model";
import { ScanCenter } from "../../../models/ScanCenter/scanCenter.model";
import { AdminFeatureEnum } from "../../../enums/AdminFeature.enum";

interface ViewerWrapperProps extends AuthReducerProps {}

function ViewerWrapper({ userRole, user }: ViewerWrapperProps) {
  const history = useHistory<any>();

  const { caseId }: any = useParams();

  const [drawerVisible, setDrawerVisible] = useState(false);

  const [me, setMe] = useState<Admin | Doctor | ScanCenter>();

  const [caseDetail, setCaseDetail] = useState<CaseDetail>();

  const [authCode, setAuthCode] = useState<string>();

  const url: string | undefined = process.env.REACT_APP_VIEWER_BASE_URL ?? "";

  const auth = localStorage.getItem("auth")
    ? JSON.parse(localStorage.getItem("auth")!)
    : null;

  useEffect(() => {
    const auth = localStorage.getItem("auth")
      ? JSON.parse(localStorage.getItem("auth")!)
      : null;
    const secretKey = "LMUqneJBeU";
    const authString = JSON.stringify(auth);
    if (auth && secretKey) {
      const encrypted = CryptoJS.AES.encrypt(authString, secretKey).toString();
      setAuthCode(encodeURIComponent(encrypted));
    }
  }, []);

  const handleDrawerOpen = () => setDrawerVisible(true);

  const handleDrawerClose = () => setDrawerVisible(false);

  useEffect(() => {
    if (caseId && userRole) {
      const showCase =
        userRole === UserRoleEnum.ADMIN
          ? AdminCaseService.showAdminCase
          : userRole === UserRoleEnum.DOCTOR
          ? DoctorCaseService.showDoctorCase
          : ScanCenterCaseService.showScanCenterCase;
      showCase(
        Number(caseId),
        (caseDetail: CaseDetail) => {
          setCaseDetail(caseDetail);
        },
        () => {},
        () => {}
      );
      ProfileService.getProfile(
        userRole,
        (me: Admin | Doctor | ScanCenter) => {
          setMe(me);
        },
        () => {},
        () => {}
      );
    }
  }, [caseId, userRole]);

  const adminFeatures =
    me?.adminFeatures?.map((feature) => feature.feature) ?? [];

  let showGenerateReport = false;
  if (userRole === UserRoleEnum.DOCTOR) {
    showGenerateReport = caseDetail?.status === CaseStatusEnum.ASSIGNED;
  } else {
    showGenerateReport =
      caseDetail?.status === CaseStatusEnum.TO_BE_APPROVED ||
      (caseDetail?.status === CaseStatusEnum.ASSIGNED &&
        user?.id === caseDetail?.assignedToAdminId);
  }

  return (
    <div className={`viewer-wrapper ${drawerVisible ? "drawer-open" : ""}`}>
      <div className="viewer-wrapper__generate-wrapper">
        {showGenerateReport && (
          <Button type="primary" onClick={handleDrawerOpen}>
            <FormOutlined />
            Generate Report
          </Button>
        )}
        <Popover
          placement="bottomLeft"
          content={<div>{caseDetail?.parsedPatientHistory || "N/A"}</div>}
          title={null}
        >
          <Button type="primary" className="ml-3">
            Case History
          </Button>
        </Popover>
      </div>
      {/* <Button
        htmlType="button"
        type="primary"
        className="viewer-wrapper__back-wrapper"
        onClick={handleGoBack}
      >
        <LeftOutlined /> Back
      </Button> */}
      <div className="viewer-wrapper__iframe-wrapper">
        {authCode && (
          <ViewerIframe
            loadAllSeries={adminFeatures.includes(
              AdminFeatureEnum.VIEWER_LOAD_ALL_SERIES
            )}
            caseId={caseId}
            url={url}
            encryptedAuth={authCode ?? ""}
          />
        )}
      </div>
      <Drawer
        className="viewer-wrapper__generate-report-drawer"
        title={null}
        width="100%"
        onClose={handleDrawerClose}
        visible={drawerVisible}
        maskClosable={false}
        footer={null}
      >
        {caseDetail && <ReportForm fromViewer caseDetailId={caseDetail.id} />}
      </Drawer>
    </div>
  );
}

export default AuthContainer(ViewerWrapper);
